const Error = () =>
(
    <div>403 Not Auth</div>
);

export default Error;